module.exports = __webpack_public_path__ + "static/media/title.00142f6c.png";